export class StringUtils {
	static format(value: string, params: any[]): string {
		params.forEach((param) => {
			value = value.replace(/:[a-zA-z]+/, param);
		});
		return value;
	}
}
